# GraphQL fragment to enable/disable Exchange sync

#import "../../../tasks/graphql/fragments/task-sync.graphql"
#import "../../../calendar/graphql/fragments/calendar-sync.graphql"

mutation setExchangeUsername($username: String) {
    setExchangeUsername(input: {exchange: {username: $username}}) {
        taskSync {
            ...TaskSync
        }
        calendarSync {
            ...CalendarSync
        }
    }
}
